import { FC } from 'react';
import { Box, Icon, Link, SimpleGrid, Text } from '@chakra-ui/react';
import { ExtendedRewardProgram } from 'types';
import { EtherscanLinkType, getEtherscanLink } from 'utils/getEtherscanLink';
import { useWeb3React } from 'hooks/web3';
import { RiExternalLinkLine } from 'react-icons/ri';

type Props = {
  program: ExtendedRewardProgram;
};

export const RewardProgramSummary: FC<Props> = ({ program }) => {
  const { chainId = 1 } = useWeb3React();

  return (
    <>
      <Box p={4}>
        <SimpleGrid columns={[1, null, null, 2]} spacingY={5}>
          <Text>
            <strong>Reward Program Address</strong>{' '}
            <Link
              href={getEtherscanLink(
                chainId,
                program.rewardProgramAddress,
                EtherscanLinkType.ADDRESS
              )}
              isExternal
            >
              {program.rewardProgramAddress} <Icon as={RiExternalLinkLine} />
            </Link>
          </Text>
          <Text>
            <strong>Powerswitch Address</strong>{' '}
            <Link
              href={getEtherscanLink(
                chainId,
                program.rewardProgram.powerSwitchAddress,
                EtherscanLinkType.ADDRESS
              )}
              isExternal
            >
              {program.rewardProgram.powerSwitchAddress}{' '}
              <Icon as={RiExternalLinkLine} />
            </Link>
          </Text>
          <Text>
            <strong>Reward Pool Address</strong>{' '}
            <Link
              href={getEtherscanLink(
                chainId,
                program.poolAddress,
                EtherscanLinkType.ADDRESS
              )}
              isExternal
            >
              {program.poolAddress} <Icon as={RiExternalLinkLine} />
            </Link>
          </Text>
          <Text>
            <strong>Staking Token URL</strong>{' '}
            <Link href={program.rewardProgram.getStakingTokenUrl} isExternal>
              {program.rewardProgram.getStakingTokenUrl}{' '}
              <Icon as={RiExternalLinkLine} />
            </Link>
          </Text>
        </SimpleGrid>
      </Box>
    </>
  );
};
